var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"circle",class:{ is360: _vm.is360 }},[_c('div',{staticClass:"tick zero"},[_vm._v("180")]),_c('div',{staticClass:"tick up"},[_vm._v("90")]),_c('div',{staticClass:"tick left"},[_vm._v("0")]),(_vm.is360)?_c('div',{staticClass:"tick down"},[_vm._v("270")]):_vm._e(),_vm._l((_vm.details),function(loop,index){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(!isNaN(_vm.selector(loop.loop))),expression:"!isNaN(selector(loop.loop))"}],key:`needle-loop-${index}-${_vm.label}`,staticClass:"needle",style:({
      transform: `translate(60px, 58px) rotate(${
        _vm.selector(loop.loop) ? _vm.selector(loop.loop) - 180 : -180
      }deg)`,
      background: loop.loop.color != null ? loop.loop.color : loop.protein.color,
    }),on:{"mouseenter":function($event){_vm.setPreview({
        $event,
        description: {
          Protein: loop.protein.name,
          Loop: loop.loop.id,
          Value: _vm.round(_vm.selector(loop.loop), 2),
        },
      })},"mouseleave":function($event){return _vm.setPreview(null)}}})}),_c('div',{staticClass:"center"},[_vm._v(_vm._s(_vm.label))])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }